import { lazy } from 'react';

export const LocationDetailPage = lazy(() => import('./LocationDetailPage'));
